import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
import { clearLoginInfo } from '@/utils'
import Vue from 'vue'
import VueI18n, { messages } from '@/i18n'
import {setLocalStorage,removeLocalStorage} from '@/utils/storage'

const messagesConst = messages[VueI18n.locale]
export const http = axios.create({
  timeout: 1000 * 800,
  withCredentials: true // 指示是否跨站点访问控制请求
})


//处理表情符号
let emoji = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c\ude32-\ude3a]|[\ud83c\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  // token
  config.headers.token = Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
  let accessWhitelistDS = Vue.prototype.getStorage(Vue.prototype.GLOBAL.ACCESS_WHITELIST_DS)
  if(typeof accessWhitelistDS !== 'undefined' && accessWhitelistDS != null && accessWhitelistDS !== ''){
    config.headers['Access-Whitelist-DS'] = accessWhitelistDS
  }  
  let params = {}
  params.originType = 'pc'
  params.key = ''
  params.sign = ''
  params.token = Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
  params.timestamp = new Date().getTime()
  if (config.method === 'get') {
    if (config.params) {
      let tmpData = JSON.stringify(config.params)
      if (emoji.test(tmpData)) {
        config.params = JSON.parse(tmpData.replace(emoji, ''))
      }
      params = config.params
    }
    config.params = {}
    params.timestamp = new Date().getTime()
    config.params = params
  } else if (config.method === 'post') {
    // params.data = config.data
    params = config.data
    config.data = params
    let tmpData = JSON.stringify(config.data)
    if (emoji.test(tmpData)) {
      config.data = JSON.parse(tmpData.replace(emoji, ''))
    }
  } else if (config.method === 'delete') {
    params = config.params
    config.params = {}
    config.params = params
  }
  return config
}, error => {
  return Promise.reject(error)
})

let errorVisible = false
/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  const code = Number(response.data.code)
  if (response.data.type && response.data.type.indexOf('octet-stream') > -1) {
    return response.data
  }
  if (response.data.type && response.data.type.indexOf('vnd.ms-excel') > -1) {
    return response.data
  }
  if (response.data.type && response.data.type.indexOf('pdf') > -1) {
    return response.data
  }
  if (!code && !response.data.type && response.data) {
    return response.data
  }
  if (code === 401) { // 401, token失效
    let url = window.location.href
    //判断是否手机端在线学习,是直接跳转登录
    if (url.indexOf('app-online-study') > -1) {
      window.sessionStorage.setItem('onlineStudy', 'onlineStudy')
    }
    if (url.indexOf('app-ai-study') > -1) {
      window.sessionStorage.setItem('AiStudy', 'AiStudy')
    }
    clearLoginInfo()
    Vue.prototype.$eventHub.$eventHub.$emit(Vue.prototype.GLOBAL.LOGOUT, '')
    router.replace({ name: 'protalMain' })
    throw response.data
  }
  if (code === -1) {
    if (response.data.data && response.data.data.errors) {
      let msg = ''
      response.data.data.errors.forEach((element, index) => {
        if (index > 0) {
          element = '，' + element
        }
        msg += element
      });
      Vue.prototype.$alert(msg, messagesConst.prompt.title)
    } else {
      Vue.prototype.$alert(response.data.msg, messagesConst.prompt.title)
    }
    throw response.data
  }
  if (response.config.url.indexOf('/sys/commuser/save') > -1) {
    return response.data
  }
  if (code)
  if (code === 40001) {
	setLocalStorage("stopTab",40001);
    router.replace({ name: 'shutdownMaintenance' })
    return
  }
  removeLocalStorage("stopTab")
  if (code === -400) {
    return response.data
  }
  if (code === -417) {
    return response.data
  }
  if (code === -254) {
    return response.data
  }
  if (code === -777) {
    Vue.prototype.$message({
      message: response.data.msg,
      type: 'error',
      duration: 3000,
    })
    throw response.data
  }
  if (code === -1032) {
    // 宝马用户不允许修改密码和忘记密码
    Vue.prototype.$alert(response.data.msg, messagesConst.prompt.title,{dangerouslyUseHTMLString: true})
    throw response.data
  }
  if (code === -1034) {
    // 宝马Q号登录禁用提醒
    Vue.prototype.$alert(response.data.msg, messagesConst.prompt.title,{dangerouslyUseHTMLString: true})
    throw response.data
  }
  // learning 定义的返回code，用来做前端判断处理
  if (code > 10000000) {
    return response.data
  }
  if (response.data instanceof Blob && response.data.type === 'application/json') {
    Vue.prototype.$alert('下载失败', messagesConst.prompt.title).then((res) => {
      console.log(res)
    }).catch((err) => {
      console.log(err)
    })
    throw response.data
  }
  if (code !== 0 && code !== 1 && code !== 2) {
    console.info(response.config.url)
    if (response.config.url.indexOf('act/operate/taskCountMT') != -1 ){
        console.info("taskCountMT error")
    } else {
        Vue.prototype.$alert(response.data.msg, messagesConst.prompt.title)
    }
    throw response.data
  }
  return response.data
}, error => {
  if (errorVisible === false) {
    errorVisible = true
    Message({
      type: 'error',
      message: '未知异常，请稍后重试！',
      onClose: function (obj) {
        errorVisible = false
      }
    })
  }
  return Promise.reject(error)
})

export default http
